import * as Sentry from '@sentry/react';
import type { WebEnv } from './env.ts';

/** Removes the URL fragment and query (invite and sign-in tokens arrive in the fragment). */
export function stripUrl(url: string): string {
  return url.replace(/[#?].*$/, '');
}

/** Error reporting. Off until VITE_SENTRY_DSN is set (a config-only switch). */
export function initSentry(env: WebEnv): boolean {
  if (!env.VITE_SENTRY_DSN) return false;
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_APP_ENV,
    // Collect nothing beyond the error and its stack.
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
      stackFrameVariables: false,
    },
    tracesSampleRate: 0,
    beforeSend(event) {
      if (event.request?.url) event.request.url = stripUrl(event.request.url);
      delete event.user;
      return event;
    },
    beforeBreadcrumb(crumb) {
      const data = crumb.data;
      if (data) {
        for (const key of ['url', 'from', 'to']) {
          const value: unknown = data[key];
          if (typeof value === 'string') data[key] = stripUrl(value);
        }
      }
      return crumb;
    },
  });
  return true;
}
